/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { Footer } from "../footer";
import get from "lodash/get";
import { HtmlSnippet } from "../html-snippet";
import { Monogram } from "../footer-helper-components";
import "./footer-one.module.css";

const FooterTemplateOne = props => {
  const copyrightText = get(props.publisherSettings, ["copyright"], "");
  const showFooterQuintypeLink = get(props.publisherTheme, ["footer-quintype-link"], "true") === "true";
  const bannerSource = get(props.publisherTheme, ["banner-source"], "");
  const footerMenu = props.menu.filter(item => item["menu-group-slug"] === "footer");
  const publisherName = get(props, ["publisherName"], "");

  return (
    <div>
      {bannerSource && <HtmlSnippet bannerSource={bannerSource} />}
      <footer styleName="wrapper" data-testid="footer">
        <div styleName="content container">
          <div data-testid="footer-logo-wrapper" styleName="logo-wrapper">
            <Monogram {...props} />
          </div>
          <div data-testid="footer-menu-wrapper" styleName="menu-wrapper">
            {!footerMenu.length ? null : (
              <ul styleName="menu">
                {footerMenu.map((item, index) => {
                  return (
                    <li data-testid="footer-menu-item" key={index}>
                      <a href={item.completeUrl}>{item.title}</a>
                    </li>
                  );
                })}
              </ul>
            )}
            <div styleName="copyright-text">{copyrightText}</div>
            {showFooterQuintypeLink && (
              <a
                data-testid="copyright-link"
                styleName="copyright-link"
                href={`https://www.quintype.com/?utm_source=${publisherName}&utm_medium=footerlink&utm_campaign=poweredby`}
                target="_blank"
                rel="noopener nofollow"
              >
                <strong>Powered by quintype</strong>
              </a>
            )}
          </div>
        </div>
      </footer>
    </div>
  );
};

FooterTemplateOne.propTypes = {
  publisherName: PropTypes.string,
  publisherSettings: PropTypes.shape({
    copyright: PropTypes.string
  }),
  publisherDomain: PropTypes.string,
  publisherTheme: PropTypes.shape({
    "footer-quintype-link": PropTypes.string,
    "banner-source": PropTypes.string
  }),
  menu: PropTypes.array
};

const FooterTemplate = () => <Footer renderTemplate={FooterTemplateOne} />;

export default FooterTemplate;
